<script setup lang="ts">
import { useLogger } from 'vue-logger-plugin'
const logger = useLogger()
import type { IAoeCartItem, IAoeCartEarnedDiscount } from '@/types/CartTypes.ts'
import {} from '@/services/CartService.ts'
import { SvgIcon } from '@progress/kendo-vue-common'
import { checkOutlineIcon } from '@progress/kendo-svg-icons'
import { FormatCurrency } from '@/services/currencyFormatter'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps<{
  earnedDiscount: IAoeCartEarnedDiscount
  GetFullProductImageUrlFromStringDictionary(productCode: string): string
  FindCartItems(poeDiscPlanLevelDiscId: number): IAoeCartItem[] | null
}>()

logger.debug('AoeCartDetailFreeProduct setup', props.earnedDiscount)

</script>
<template>
  <div
    v-for="item in FindCartItems(props.earnedDiscount.poeDiscPlanLevelDiscId)"
    :key="item.skuCode"
    class="row free-item-row">
    <div class="col-2 col-md-1 free-item-chosen-check">
      <SvgIcon
        class="check-mark-outline-icon"
        :icon="checkOutlineIcon">
      </SvgIcon>
    </div>
    <div
      class="col-4 col-md-2 discountMessage free-item-message"
      v-html="(item.quantity > 1 ? t('labels.FreeProductQuantityPrefix', { quantity: item.quantity }) : '') + props.earnedDiscount.awardMessage">
    </div>
    <div
      v-if="props.GetFullProductImageUrlFromStringDictionary(item.productCode) !== '#'"
      class="col-6 col-md-3 free-item-chosen-image">
      <img :src="props.GetFullProductImageUrlFromStringDictionary(item.productCode)" class="img-fluid prodImage" :alt="t('cart.ProductImageAlt')"/>
    </div>
    <div class="col-12 col-md-6 free-item-chosen-name">
      {{ item.skuName }}<span class="strike-through cart-item-retail-price">{{ FormatCurrency(item.price, null) }}</span><span class="cart-item-price">{{ FormatCurrency(item.totalDiscountAmount ? (item.price * item.quantity) - item.totalDiscountAmount : item.price, null) }}</span>
    </div>
  </div>
</template>

<style lang="scss">

.free-item-chosen-check,
.free-item-chosen-name {
    align-content: center;
}

</style>
